const BAU_COLLECTION_HANDLES = {
  gpay: 'shop-all-gpay',
};

const BAU_SWAPPED_KEY = 'bau_swapped_variants';

// Cached once in bauInit — the cart-drawer element and overlay never leave the DOM
let _bauDrawer = null;
let _bauOverlay = null;
let _bauCartPage = null;

function bauMarkSwapDone(originalVariantId) {
  const id = String(originalVariantId);
  const swapped = JSON.parse(sessionStorage.getItem(BAU_SWAPPED_KEY) || '[]');
  if (!swapped.includes(id)) {
    swapped.push(id);
    sessionStorage.setItem(BAU_SWAPPED_KEY, JSON.stringify(swapped));
  }
}

function bauHideCompletedSwaps(container) {
  if (!container) return;
  const swapped = JSON.parse(sessionStorage.getItem(BAU_SWAPPED_KEY) || '[]');
  if (!swapped.length) return;
  container.querySelectorAll('[data-bau-swap]').forEach((swapEl) => {
    const btn = swapEl.querySelector('[data-bau-swap-card]');
    if (!btn) return;
    if (swapped.includes(String(btn.dataset.originalVariantId))) {
      swapEl.style.display = 'none';
    }
  });
}

function bauPostRender() {
  bauHideCompletedSwaps(_bauDrawer);
  bauHideCompletedSwaps(_bauCartPage);
  bauUpdateSavingsBadge();
}

function bauDetectCollection() {
  const path = window.location.pathname.toLowerCase();
  if (path.includes(BAU_COLLECTION_HANDLES.gpay)) return 'gpay';
  return 'standard';
}

function bauReadConfig() {
  const configEl = document.getElementById('bau-config');
  if (!configEl) return {};
  try {
    return JSON.parse(configEl.textContent);
  } catch (_) {
    return {};
  }
}

function bauGetDiscountRate(productType, collection, cartTotalPaise, discountThresholdPaise, tier1ThresholdPaise, tier1DiscountActive, isExcluded) {
  if (isExcluded) return 0;
  if (productType.toLowerCase() === 'combo') {
    return 0.25;
  }
  if (collection === 'gpay') return 0;
  if (cartTotalPaise >= discountThresholdPaise) return 0.2;
  if (tier1DiscountActive && cartTotalPaise < tier1ThresholdPaise) return 0.1;
  return 0.15;
}

function bauReadPageConfig() {
  const el = document.getElementById('bau-page-config');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (_) { return null; }
}

function bauUpdateSavingsBadgeIn(container, config) {
  if (!container || !config) return;

  const collection = bauDetectCollection();
  const cartTotalPaise = config.cart_total_paise != null ? config.cart_total_paise : 0;
  const discountThresholdPaise = config.discount_threshold_paise != null ? config.discount_threshold_paise : 99900;
  const tier1ThresholdPaise = config.tier1_threshold_paise != null ? config.tier1_threshold_paise : 0;
  const tier1DiscountActive = config.tier1_discount_active != null ? config.tier1_discount_active : false;
  const excludedProductIds = Array.isArray(config.excluded_product_ids)
    ? config.excluded_product_ids.map((id) => String(id))
    : [];
  // Metaobject "Dynamic Discount" — listed products get this flat % instead of
  // the combo/tier rate (exclusion still wins). Mirrors snippets/cart-mode-bau.liquid.
  const dynamicRate = (parseFloat(config.dynamic_discount_pct) || 0) / 100;
  const dynamicProductIds = Array.isArray(config.dynamic_discount_product_ids)
    ? config.dynamic_discount_product_ids.map((id) => String(id))
    : [];

  let totalSavings = 0;
  let totalOrderRupees = 0;

  const rows = container.querySelectorAll('.cart-line-item');
  rows.forEach((row) => {
    if (row.closest('.cart_offer_product_wrap')) return;

    const productType = row.dataset.productType != null ? row.dataset.productType : '';
    const isExcluded = excludedProductIds.includes(row.dataset.productId || '');
    const priceEl = row.querySelector('[data-original-price]');
    if (!priceEl) return;

    let originalRupees = parseFloat(priceEl.dataset.originalPrice);
    if (Number.isNaN(originalRupees)) {
      const raw = priceEl.textContent.replace(/[^0-9.]/g, '');
      originalRupees = parseFloat(raw) || 0;
      priceEl.dataset.originalPrice = String(originalRupees);
    }

    totalOrderRupees += originalRupees;

    const isDynamic = !isExcluded && dynamicRate > 0 && dynamicProductIds.includes(row.dataset.productId || '');
    const rate = isDynamic
      ? dynamicRate
      : bauGetDiscountRate(productType, collection, cartTotalPaise, discountThresholdPaise, tier1ThresholdPaise, tier1DiscountActive, isExcluded);
    if (rate > 0) {
      totalSavings += originalRupees * rate;

      const displayPriceEl = priceEl.querySelector('[data-bau-display-price]');
      const comparePriceEl = priceEl.querySelector('[data-bau-compare-price]');
      if (displayPriceEl) {
        const discountedRupees = Math.round(originalRupees * (1 - rate));
        displayPriceEl.textContent = `₹${discountedRupees.toLocaleString('en-IN')}`;
      }
      if (comparePriceEl) {
        comparePriceEl.textContent = `₹${Math.round(originalRupees).toLocaleString('en-IN')}`;
        comparePriceEl.style.display = '';
      }
    }
  });

  const freebieItems = container.querySelectorAll('.bau-freebie-item');
  freebieItems.forEach((item) => {
    const strikeEl = item.querySelector('.bau-freebie-item__price s');
    if (!strikeEl) return;
    const mrp = parseFloat(strikeEl.textContent.replace(/[^0-9.]/g, '')) || 0;
    if (mrp > 1) {
      totalSavings += mrp - 1;
      totalOrderRupees += mrp;
    }
  });

  const badgeEl = container.querySelector('[data-bau-savings-display]');
  const amountEl = container.querySelector('[data-bau-savings-amount]');
  if (!badgeEl || !amountEl) return;

  if (totalSavings <= 0) {
    badgeEl.classList.add('hidden');
    return;
  }

  amountEl.textContent = `-You saved ₹${Math.round(totalSavings).toLocaleString('en-IN')}`;
  badgeEl.classList.remove('hidden');

  const orderTotalEl = container.querySelector('[data-cart-page-order-total]');
  const savingsRowEl = container.querySelector('[data-cart-page-savings-row]');
  const savingsEl = container.querySelector('[data-cart-page-savings]');
  if (orderTotalEl) orderTotalEl.textContent = `₹${Math.round(totalOrderRupees).toLocaleString('en-IN')}`;
  if (savingsRowEl && savingsEl) {
    savingsEl.textContent = `-₹${Math.round(totalSavings).toLocaleString('en-IN')}`;
    savingsRowEl.classList.add('is-visible');
  }
}

function bauUpdateSavingsBadge() {
  const drawerConfig = bauReadConfig();
  if (_bauDrawer) bauUpdateSavingsBadgeIn(_bauDrawer, drawerConfig);

  const pageEl = document.querySelector('[data-cart-page]');
  if (pageEl) {
    const pageConfigRaw = bauReadPageConfig();
    const pageConfig = pageConfigRaw != null ? pageConfigRaw : drawerConfig;
    bauUpdateSavingsBadgeIn(pageEl, pageConfig);
  }
}

function bauShowOverlay(show) {
  if (!_bauOverlay) return;
  _bauOverlay.style.removeProperty('display');
  _bauOverlay.classList.toggle('is-visible', show);
}

async function bauPerformSwap(swapVariantId, originalVariantId) {
  bauMarkSwapDone(originalVariantId);
  bauShowOverlay(true);

  try {
    const formData = new FormData();
    formData.append('id', swapVariantId);
    formData.append('quantity', '1');
    formData.append('properties[swapped_from_variant_id]', originalVariantId);
    formData.append('properties[is_app]', 'true');

    await CartAPI.add(formData, []);
    await CartAPI.update({ updates: { [originalVariantId]: 0 } }, []);

    const sectionIds = [];
    if (_bauDrawer && _bauDrawer.dataset.sectionId) sectionIds.push(_bauDrawer.dataset.sectionId);
    const cartPageSectionId = _bauCartPage && _bauCartPage.dataset.sectionId;
    if (cartPageSectionId) sectionIds.push(cartPageSectionId);

    const data = await CartAPI.update({}, sectionIds);

    if (_bauDrawer) _bauDrawer.renderContents(data);
    if (_bauCartPage && cartPageSectionId && data.sections && data.sections[cartPageSectionId]) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data.sections[cartPageSectionId], 'text/html');
      const incoming = doc.querySelector('[data-cart-page]');
      if (incoming) _bauCartPage.innerHTML = incoming.innerHTML;
    }

    requestAnimationFrame(bauPostRender);
  } catch (_) {
  } finally {
    bauShowOverlay(false);
  }
}

async function bauPerformUndoSwap(originalVariantId, swapVariantId) {
  bauShowOverlay(true);

  try {
    const formData = new FormData();
    formData.append('id', originalVariantId);
    formData.append('quantity', '1');
    formData.append('properties[is_app]', 'true');

    await CartAPI.add(formData, []);
    if (swapVariantId) {
      await CartAPI.update({ updates: { [swapVariantId]: 0 } }, []);
    }

    const sectionIds = [];
    if (_bauDrawer && _bauDrawer.dataset.sectionId) sectionIds.push(_bauDrawer.dataset.sectionId);
    const cartPageSectionId = _bauCartPage && _bauCartPage.dataset.sectionId;
    if (cartPageSectionId) sectionIds.push(cartPageSectionId);

    const data = await CartAPI.update({}, sectionIds);

    if (_bauDrawer) _bauDrawer.renderContents(data);
    if (_bauCartPage && cartPageSectionId && data.sections && data.sections[cartPageSectionId]) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data.sections[cartPageSectionId], 'text/html');
      const incoming = doc.querySelector('[data-cart-page]');
      if (incoming) _bauCartPage.innerHTML = incoming.innerHTML;
    }

    requestAnimationFrame(bauPostRender);
  } catch (_) {
  } finally {
    bauShowOverlay(false);
  }
}

function bauAttachSwapHandlersTo(container) {
  if (!container) return;

  container.addEventListener('click', (event) => {
    const swapCard = event.target.closest('[data-bau-swap-card]');
    if (swapCard) {
      event.preventDefault();
      const { swapProductId, originalVariantId } = swapCard.dataset;
      bauPerformSwap(swapProductId, originalVariantId);
      return;
    }

    const undoBtn = event.target.closest('[data-undo-swap]');
    if (undoBtn) {
      const { originalVariantId, swapVariantId } = undoBtn.dataset;
      bauPerformUndoSwap(originalVariantId, swapVariantId != null ? swapVariantId : null);
    }
  });

  container.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const swapCard = event.target.closest('[data-bau-swap-card]');
    if (swapCard) {
      event.preventDefault();
      const { swapProductId, originalVariantId } = swapCard.dataset;
      bauPerformSwap(swapProductId, originalVariantId);
    }
  });
}

function bauAttachSwapHandlers() {
  bauAttachSwapHandlersTo(_bauDrawer);
  bauAttachSwapHandlersTo(_bauCartPage);
}

function bauInit() {
  _bauDrawer = document.querySelector('cart-drawer');
  _bauOverlay = document.querySelector('[data-atc-screen-overlay]');
  _bauCartPage = document.querySelector('[data-cart-page]');
  bauAttachSwapHandlers();
  requestAnimationFrame(bauPostRender);
}

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => requestAnimationFrame(bauPostRender));
  subscribe(PUB_SUB_EVENTS.cartAdd, () => requestAnimationFrame(bauPostRender));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bauInit);
} else {
  bauInit();
}

// iOS Safari uses the back-forward cache far more aggressively than desktop
// Chrome: navigating back to this page can restore the exact frozen DOM/JS
// state from before without re-running any script. event.persisted is true
// only on that kind of restore, so this re-syncs the savings badge/prices
// against whatever the cart actually is now, in case it changed while frozen.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) requestAnimationFrame(bauPostRender);
});

// ── Bundle total for Customers Also Bought (and any future bundle section) ───
// Pure calculation — no DOM reads/writes. Reuses bauGetDiscountRate(),
// bauDetectCollection(), and bauReadConfig() already defined in this file.
//
// items: [{ price (paise), productType, productId? }]
// Returns discounted total in paise.
(function () {
  function bauCalcBundleTotal(items) {
    if (!items || !items.length) return 0;

    const collection = bauDetectCollection();
    const config = bauReadConfig();
    const discountThresholdPaise = config.discount_threshold_paise != null
      ? config.discount_threshold_paise
      : 99900; // ₹999 default
    const tier1ThresholdPaise = config.tier1_threshold_paise != null ? config.tier1_threshold_paise : 0;
    const tier1DiscountActive = config.tier1_discount_active != null ? config.tier1_discount_active : false;

    // Tier is judged on the selected bundle products alone. recalcTotals() in
    // customers-also-bought.js re-invokes this on every card toggle, so the rate
    // switches live: all products selected (≥ threshold) → 20%, unselect down
    // below the threshold → 15%, with no reload. Existing cart contents are
    // intentionally excluded so they never inflate the bundle's tier.
    const totalForThreshold = items.reduce(function (s, i) { return s + Number(i.price || 0); }, 0);

    const dynamicRate = (parseFloat(config.dynamic_discount_pct) || 0) / 100;
    const dynamicProductIds = Array.isArray(config.dynamic_discount_product_ids)
      ? config.dynamic_discount_product_ids.map(function (id) { return String(id); })
      : [];
    const excludedProductIds = Array.isArray(config.excluded_product_ids)
      ? config.excluded_product_ids.map(function (id) { return String(id); })
      : [];

    return items.reduce(function (sum, item) {
      const price = Number(item.price || 0);
      const productId = String(item.productId || '');
      const isDynamic = dynamicRate > 0
        && dynamicProductIds.includes(productId)
        && !excludedProductIds.includes(productId);
      const rate = isDynamic ? dynamicRate : bauGetDiscountRate(
        item.productType || '',
        collection,
        totalForThreshold,
        discountThresholdPaise,
        tier1ThresholdPaise,
        tier1DiscountActive
      );
      // Mirror Liquid: | times: (1 - rate) | round
      return sum + Math.round(price * (1 - rate));
    }, 0);
  }

  window.DnkPricing = { calcBundleTotal: bauCalcBundleTotal };
})();
